export default __webpack_public_path__ + "static/media/lupa blanca.32524c7d.svg";